import { render, staticRenderFns } from "./OfficeDocuments.vue?vue&type=template&id=086c8bbf&scoped=true&"
import script from "./OfficeDocuments.vue?vue&type=script&lang=js&"
export * from "./OfficeDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OfficeDocuments.vue?vue&type=style&index=0&id=086c8bbf&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c8bbf",
  null
  
)

export default component.exports